import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    connectionId: ""
};

const signalRSlice = createSlice({
    name: "signalR",
    initialState: initialState,
    reducers:{
        setSignalRConnectionId: (state, action) =>  ({...state, connectionId: action.payload})
    }
});

export default signalRSlice.reducer;

export const { setSignalRConnectionId } = signalRSlice.actions;